export const FEATURE_NAME = '@zerops/zerops/feature/shared-ipv4';
